import * as React from 'react'
import { Select, SelectProps } from 'cs-kevlar-react/lib/es/Select'
import { FormHelperText } from 'cs-kevlar-react'
import dotProp from 'dot-prop'

export type FormikSelectProps = SelectProps & {
  formikProps: any
  fieldName: string
  helperText?: string
}

export const FormikSelect = ({
  formikProps,
  fieldName,
  id = fieldName,
  helperText,
  ...rest
}: FormikSelectProps) => {
  const hasError =
    formikProps.touched[fieldName] && formikProps.errors[fieldName]
  const error = formikProps.errors[fieldName]
  const value = dotProp.get(formikProps.values, fieldName)

  // add a placeholder that is the same height as the error helper text
  return (
    <React.Fragment>
      <Select
        error={hasError}
        id={fieldName}
        name={fieldName}
        onChange={formikProps.handleChange}
        onBlur={formikProps.handleBlur}
        value={value}
        {...rest}
      />
      {!hasError && !helperText && <FormHelperText></FormHelperText>}
      {!hasError && !!helperText && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
      {hasError && <FormHelperText error>{error}</FormHelperText>}
    </React.Fragment>
  )
}
